module.exports = __webpack_public_path__ + "img/neck.3314dcc7.svg";